import apiChange from '../apiChange';

import { ParamsBodyConfirmOrder, ParamsDataConfirmOrder } from 'utils/typeServices';

type response = {
    errorCode: null;
    message: string;
    success: boolean;
    data: ParamsDataConfirmOrder;
}

export const PostConfirmOrder = async ({ body }: { body: ParamsBodyConfirmOrder }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeservice/confirmOrder/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
